import type { RouteLocationNormalized } from "vue-router"

import * as configurationApi from "@/api/configuration/api"
import DefaultLayout from "@/layouts/DefaultLayout/DefaultLayout.vue"
import { setRouteParam } from "@/types/routerPrefetch"

export default [
    {
        path: "/system-setting",
        name: "system-setting-wrapper",
        meta: {
            isShow: false,
            position: "",
            name: "系統設定",
        },
        component: DefaultLayout,
        children: [
            {
                path: "",
                component: () => import("@/pages/CommonGroup/SystemSettingPage.vue"),
                name: "system-setting",
                meta: {
                    requiresAuth: true,
                },
                props: true,
                beforeEnter: async (to: RouteLocationNormalized) => {
                    try {
                        const response = await configurationApi.getConfiguration()

                        setRouteParam(to.params, "initialConfigurationResponse", response)

                        return true
                    } catch (error) {
                        console.error(error)
                        return false
                    }
                },
            },
        ],
    },
]
